import { createStyles } from '@/contexts/theme-context';
import { LayoutChangeEvent } from 'react-native';
import { TypographyVariant } from '@usepepper/ui/atoms/typography';
import { useCallback, useState } from 'react';

const LARGE_SCREEN_WIDTH = 1024;
const STACKED_MAX_WIDTH = 720;

export const usePricingSummaryHeaderLayout = () => {
  const [styles] = useStyles();
  const [layoutWidth, setLayoutWidth] = useState<number | null>(null);

  const handleLayout = useCallback((event: LayoutChangeEvent) => {
    setLayoutWidth(event.nativeEvent.layout.width);
  }, []);

  const isLarge = layoutWidth !== null && layoutWidth >= LARGE_SCREEN_WIDTH;
  const isStacked = layoutWidth !== null && layoutWidth < STACKED_MAX_WIDTH;

  return {
    containerStyle: styles.container,
    handleLayout,
    headingVariant: (isLarge
      ? 'heading-2xl'
      : 'heading-xl') as TypographyVariant,
    isLarge,
    isStacked,
    wrapperStyle: [
      styles.wrapper,
      isLarge ? styles.wrapperPaddingLarge : styles.wrapperPaddingMedium,
      isStacked ? styles.wrapperStacked : null,
    ],
  };
};

const useStyles = createStyles((theme) => ({
  container: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
  wrapper: {
    backgroundColor: theme.sk.color.bg.secondary.default,
    borderRadius: theme.sk.radii.radiusMedium,
    columnGap: theme.sk.spacing.spaceXlarge,
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    rowGap: theme.sk.spacing.spaceLarge,
  },
  wrapperPaddingLarge: {
    paddingHorizontal: theme.sk.spacing.space4xlarge,
    paddingVertical: theme.sk.spacing.spaceXlarge,
  },
  wrapperPaddingMedium: {
    paddingHorizontal: theme.sk.spacing.spaceXlarge,
    paddingVertical: theme.sk.spacing.spaceLarge,
  },
  wrapperStacked: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));
